/**
 * The Growth Plan's name for whoever is looking (HR UAT list #3): People Leader
 * views say "Growth Plan"; the Team Member's own views keep "My Personalised
 * Growth". A component that serves both names it by the viewer's role.
 */
export type GrowthPlanViewer = 'manager' | 'employee'

export function growthPlanName(viewer: GrowthPlanViewer): string {
  return viewer === 'manager' ? 'Growth Plan' : 'My Personalised Growth'
}
